<template>
  <div class="r-15-0">
    <p class="faculdade_director_texto"
       :class="faculdadename">
      {{texto}}
    </p>
  </div>
</template>

<script>
export default {
  name: "TextoPresidente",
  props:["texto","faculdadename"]
}
</script>

<style scoped lang="scss">
@import "../global.scss";

.r-15-0{
  margin-left: 15px;
  margin-right: 15px;
}

@media (max-width: 1024px) {
  .r-15-0 {
    margin: 0;
  }
}

/*119*/
.faculdade_director_texto {
  font-family: "PT Sans Italic";
  font-size: 24px;
  line-height: 1.8;
  padding-top: 145px;
  padding-bottom: 5px;
  color: #333333;
  margin-right: 0;
  padding-right: 10px;
  position: relative;
}

.faculdade_director_texto:before{
  content: "“";
  position: absolute;
  font-family: 'PT Sans Italic';
  font-size: 135px;
  color: #ff4d4d;
  top: 50px;
  left: -70px;
}

@media (max-width: 1500px) {
  .faculdade_director_texto:before {
    left: -55px;
    top: 15px;
  }

  .faculdade_director_texto {
    line-height: 1.8;
    font-size: 24px;
  }

  .faculdade_director_texto {
    padding-top: 75px;
  }

}

@media (max-width: 1024px) {
  .faculdade_director_texto:before{
    left: -15px;
    top:-80px;
  }
}

@media (max-width: 767px) {
  .faculdade_director_texto:before{
    left: -15px;
    top:-20px;
  }
}


@media (max-width : 1500px) {

  .faculdade_director_texto {
    padding-top: 65px;
  }

  .faculdade_director_texto:before {
    top: -15px;
  }

}

/*1083*/
@media (min-width : 768px)
and (max-width : 1024px) {

  /*1172*/
  .faculdade_director_texto {
    padding-right: 0;
  }


  /*1296*/
  .faculdade_director_texto {
    font-family: "PT Sans Italic";
    padding-bottom: 5px;
    color: #333333;
    margin-right: 0;
    font-size: 23px;
    padding-left: 5px;
    padding-top: 30px;
  }

}

@media (max-width: 767px) {


  /*1513*/
  .faculdade_director_texto {
    font-size: 20px;
    line-height: 1.69;
    padding-top: 75px;
  }

  /*1528*/
  .faculdade_director_texto {
    padding-right: 0;
    padding-top: 85px;
  }
}



@media (max-width: 839px) {

  .faculdade_director_texto {
    padding-right: 0;
    padding-left: 0;
    font-size: 17px;
    line-height: 1.5;
  }

  .faculdade_director_texto:before {
    font-size: 100px;
  }

  .faculdade_director_texto {
    padding-top: 50px;
  }

}


.faculdade_director_texto.artesehumanidades:before{
  color: $ahline;
}

.faculdade_director_texto.cienciasexatasedaengenharia:before{
  color: $ceeline;
}

.faculdade_director_texto.cienciassociais:before{
  color: $csline;
}

.faculdade_director_texto.cienciasdavida:before{
  color: $cvhline;
}

.faculdade_director_texto.tecnologiasegestao:before{
  color: $tghline;
}

.faculdade_director_texto.escolasuperiordesaude:before{
  color: $ssline;
}

.faculdade_director_texto.escolasuperiordetecnologiasegestao:before{
  color: $tghline;
}

</style>